/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types,jsx-a11y/no-noninteractive-element-interactions,no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PublicSearchUsersListContainer from 'components/Users/containers/PublicSearchUsersListContainer';
import classNames from 'classnames';
import OpacityPreLoader from 'components/Common/PreLoaders/OpacityPreLoader';
import { t } from 'utils/translates';

import AddUserItem from './common/AddUserItem';

// eslint-disable-next-line react/prefer-stateless-function
class PublicSearchUserBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'refs',
      searchString: this.props.selectQueryParams.username
    };
  }

  selectTabAll() {
    if (this.state.activeTab !== 'all') {
      this.setState({ activeTab: 'all' });
      this.props.changeQueryParams({
        onlyAdmins: 0,
        onlyMyRefUsers: 0
      });
      if (
        this.props.selectQueryParams.username !== '' &&
        this.props.selectQueryParams.username !== undefined
      ) {
        this.props.sendRequest();
      }
    }
  }

  selectTabAdmins() {
    if (this.state.activeTab !== 'admins') {
      this.setState({ activeTab: 'admins' });
      this.props.changeQueryParams({
        onlyAdmins: 1,
        onlyMyRefUsers: 0
      });
      this.props.sendRequest();
    }
  }

  selectTabRefs() {
    if (this.state.activeTab !== 'refs') {
      this.setState({ activeTab: 'refs' });
      this.props.changeQueryParams({
        onlyAdmins: 0,
        onlyMyRefUsers: 1
      });
      this.props.sendRequest();
    }
  }

  handlerSearch() {
    this.props.changeQueryParams({
      username: this.state.searchString
    });
    this.props.sendRequest();
  }

  render() {
    let searchContent = null;
    if (
      this.state.activeTab === 'all' &&
      (this.props.requestState.countQueries === 0 ||
        this.props.selectQueryParams.username === '' ||
        this.props.selectQueryParams.username === undefined)
    ) {
      searchContent = (
        <div className="alert alert-default text-center">
          <p>{t('Воспользуйтесь поиском по пользователям')}</p>
        </div>
      );
    } else if (this.props.itemsIds.length === 0) {
      searchContent = (
        <div className="alert alert-default text-center">
          <p>{t('По вашему запросу ничего не найдено')} :-(</p>
        </div>
      );
    } else if (this.props.itemsIds.length > 0) {
      searchContent = (
        <table className="table">
          <tbody>
            {this.props.itemsIds.map(itemId => (
              <AddUserItem
                key={`AddUserItem${itemId}`}
                item={this.props.selectItemById(itemId)}
              />
            ))}
          </tbody>
        </table>
      );
    }

    return (
      <div>
        <div className="input-group" style={{ margin: '20px' }}>
          <input
            className="form-control ng-pristine ng-valid ng-touched"
            name="formImgAddUrl"
            placeholder={t('Введите имя пользователя')}
            type="text"
            value={this.state.searchString}
            onKeyDown={e => {
              if (e.keyCode === 13) {
                this.handlerSearch();
              }
            }}
            onChange={e => {
              e.preventDefault();
              this.setState({ searchString: e.target.value });
            }}
          />
          <span className="input-group-btn">
            <button
              className="btn btn-default"
              type="button"
              onClick={e => {
                e.preventDefault();
                this.handlerSearch();
              }}
            >
              <i className="fa fa-search" /> {t('Искать')}
            </button>
          </span>
        </div>
        <div className="panel-bar">
          <ul className="nav nav-tabs nav-tabs-lg">
            {/* <li
              className={classNames({ active: this.state.activeTab === 'all' })}
            >
              <a
                href=""
                onClick={e => {
                  e.preventDefault();
                  this.selectTabAll();
                }}
              >
                Результаты поиска
              </a>
            </li> */}
            <li
              className={classNames({
                active: this.state.activeTab === 'refs'
              })}
            >
              <a
                href=""
                onClick={e => {
                  e.preventDefault();
                  this.selectTabRefs();
                }}
              >
                {t('Мои рефералы')}
              </a>
            </li>
            <li
              className={classNames({
                active: this.state.activeTab === 'admins'
              })}
            >
              <a
                href=""
                onClick={e => {
                  e.preventDefault();
                  this.selectTabAdmins();
                }}
              >
                {t('Администрация')}
              </a>
            </li>
          </ul>
        </div>
        <div style={{ margin: '20px' }} className="pos-rel">
          {this.props.requestState.inProgress ? <OpacityPreLoader /> : null}
          {searchContent}
        </div>
      </div>
    );
  }
}

PublicSearchUserBlock.propTypes = {
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,
  // CONNECT DISPATCH
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  selectQueryParams: PropTypes.shape({
    username: PropTypes.string,
    onlyAdmins: PropTypes.number,
    onlyMyRefUsers: PropTypes.number
  }).isRequired,

  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicSearchUsersListContainer(PublicSearchUserBlock));



// WEBPACK FOOTER //
// ./src/components/Messenger/content/MessengerGroupRoomFormPopUp/PublicSearchUserBlock.js